import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import Paginate from "vuejs-paginate";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import PageTracker from '../../../common/PageTrackerHelper'

export default {
  name: 'ChangeRTOandShipmentDetails',
  components: {
      VueElementLoading,
      Treeselect,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
          RTODetails : 0,
          ShipmentDetails : 1,
          changeStatus : '',
          singleShipment:0,
          bulkShipment:1,
          changeShipmentStatusflag:'',
          rblBulkIsRedirect : 0,
          rblBulkIsRedirect1 : '',
          txtShipmentId : '',
          rtodto:'',
          buttonflag1 : '',
          buttonflag : '',
          singleShipmentrtodto:0,
          bulkShipmentrtodto:1,
          changeShipmentStatusflagrtodto:'',
          shipmetsflagforshow:0,
          shippingDetailsShow : false,
          shippingRTODetailsShow : false,
          shippingRTODetailsChangeHubShow : false,
          shippingDetailsShow1:false,
          txtShipmentId1:'',
          shipDetails :{
            ShippingComments : '',
            ShippingPincode : '',
            mobileno : '',
            ShippingState : '',
            ShippingCity : '',
            shippingAddress : '',
            SolID:''
          },
          newRTOStateObj : [],
          newRTOCityObj : [],
          reasonObj : [{"ReasonsID" : "1","Reason":"change shipment status"},{"ReasonsID" : "2","Reason":"change shipment RTOToHub status"}],
          NewRTOReason : {},
          NewRTODetails :{
            newRTOName : '',
            NewRTOAddress : '',
            NewRTOPincode : '',
            NewRTOmobileno : '',
            newRTOCity : '',
            newRTOState : '',
            NewRTOReason : ''
          },
          CopyAddressCheck : false,
          CurrentRTODetails :{
            RTOTOHubId : '',
            RTOTOName : '',
            changeRTOTOHubId : '',
            RTOReason : ''
          },
          PrevRTODetails : {
            Shippingid : '15972693513',
            RTOName : 'Wakad (Hill Road)',
            RTOAddress : 'BUSYBEES Logistics Solutions,S.No. 584(New), S.no. 393(old),Devanahalli village, Kasaba Hobli, Devanahalli taluk Land Mark: Opp. Merusri Springs, Near Brigade Orchards',
            RTOState : 'Karnataka',
            RTOCity : 'Bangalore',
            RTOPincode : '562110',
            RTOMobileNo : '9035897770',
            Status : 'RTO',
            ShipmentStatus : ''
          },
          changeRTOTOHubIdObj : [],
          AllcitiesObj : [],
          groupedErrors : [],
          Loading: false,
          checkDuplicate : '',
          userDataKey : '',
      }
  },
  created: function() {
    this.getHubList();
    this.getState();
    this.getAllCity();


  },
  async mounted(){
   this.userDataKey = window.localStorage.getItem('userUniqueKey');
   let validateUser = await this.validateJwtToken();
   var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
   var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
   var plaintext = bytes.toString(CryptoJS.enc.Utf8);
   var userdetail = JSON.parse(plaintext);
   this.localuserid = userdetail.userid;
   this.localusermailid = userdetail.email;
   this.rolename = userdetail.userrole[0]['rolename'];
   this.hubdetails = userdetail.hubdetails[0];

  //  let TrackerInfo = {
  //      projectname:"Last Mile",
  //      type:"Web",
  //      userid:this.localuserid,
  //      username:this.localusermailid,

  //      meta: {
  //          "event":""
  //      }
  //  }
  //  let result  = this.PageTracker(TrackerInfo);
  //  console.log('result page tracker',result );
  },
  methods : {
    getState(){
     axios.get(apiUrl.api_url + 'getstate/list', {})
      .then((response) => {
          if(response.data.code===200){
              this.newRTOStateObj =response.data.data;
              //console.log("this.StateObj",this.StateObj);
          }
          else {
              this.newRTOStateObj=[];
          }
      })
      .catch((httpException) => {
          this.$alertify.error("State data not found");
          console.error('exception is:::::::::', httpException)
      })
    },
    getAllCity(){

      axios.post(apiUrl.api_url + 'city/list', {})
       .then((response) => {
           if(response.data.code===200){
               this.AllcitiesObj =response.data.data;
               //console.log('this.AllCityObj : ',this.newRTOCityObj);
           }
           else {
               this.AllcitiesObj=[];
           }
       })
       .catch((httpException) => {
           this.$alertify.error("City data not found");
           console.error('exception is:::::::::', httpException)
       })
     },

    getCity(){

      let stateId;
        if(this.changeStatus == 1){
          stateId = this.shipDetails.ShippingState.toString();
        }else{

          stateId = this.NewRTODetails.newRTOState.toString();
        }

        if(stateId == '' || stateId == undefined){
          return false;
        }
        axios.post(apiUrl.api_url + 'city/list', {"stateId":stateId})
         .then((response) => {
             if(response.data.code===200){
                 this.newRTOCityObj =response.data.data;
                 //console.log('this.CityObjSingle : ',this.newRTOCityObj);
             }
             else {
                 this.newRTOCityObj=[];
             }
         })
         .catch((httpException) => {
             this.$alertify.error("City data not found");
             console.error('exception is:::::::::', httpException)
         })
     },
    checkAddres(e){
      if(e.target.checked == true){
        this.CopyAddressCheck = true;
        this.NewRTODetails = {
          "newRTOName" : this.PrevRTODetails.RTOName,
          "NewRTOAddress" : this.PrevRTODetails.RTOAddress,
          "NewRTOPincode" : this.PrevRTODetails.RTOPincode,
          "NewRTOmobileno" : this.PrevRTODetails.RTOMobileNo,
          "newRTOCity" : '',
          "newRTOState" : '',
          "NewRTOReason" : ''
        }
      }else{
        this.CopyAddressCheck = false;
        this.NewRTODetails = {};
        this.$validator.reset();
        this.errors.clear();
      }
    },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          var payload = {
              shippingID : this.txtShipmentId.trim()
            }

          if(this.rtodto === "2" ){
              axios.post(apiUrl.api_url + 'shipmentMisrout/getShipmemtsdetails', payload)
              .then((response) => {
                    if(response.data.code === 200){

                      if((response.data.data.CurrentHubID != '' || response.data.data.CurrentHubID != null) && response.data.data.CurrentHubID == this.hubdetails) {
                          if(response.data.data.IsRedirect == null){
                            this.rblBulkIsRedirect1 = 0;
                          }else{
                            this.rblBulkIsRedirect1 = 1;
                          }
                          this.PrevRTODetails = {
                            'Shippingid' :this.txtShipmentId,
                            'RTOName' : response.data.data.RTODetails.Addresses[0].Name,
                            'RTOAddress' : response.data.data.RTODetails.Addresses[0].Address,
                            'RTOState' : response.data.data.RTODetails.Addresses[0].State,
                            'RTOCity' : response.data.data.RTODetails.Addresses[0].City,
                            'RTOPincode' : (response.data.data.RTODetails.Addresses[0].PinCode).toString(),
                            'RTOMobileNo' : response.data.data.RTODetails.ContactDetails[0].PhoneNo,
                            'Status': response.data.data.Status,
                            'ShipmentStatus': response.data.data.ShipmentStatus
                          }
                          this.NewRTODetails = {};
                          this.$validator.reset();
                          this.errors.clear();
                          this.CopyAddressCheck = false

                          //console.log('response.data.data.ShipmentStatus',typeof(response.data.data.Status));
                          this.shippingDetailsShow = true;
                          if(response.data.data.Status == 'RTO'){
                            this.shippingRTODetailsShow = true;
                          } else {
                            this.shippingRTODetailsShow = false;
                            this.shippingRTODetailsChangeHubShow = false;
                             this.$alertify.error("Invalid Shipment Status!! "+response.data.data.Status);
                          }
                          let id = response.data.data.CurrentHubID;
                           axios.post(apiUrl.api_url + 'shipments/getHubNameByHubId', {"id":id})
                           .then((responseResult) => {
                              //console.log('CurrentHubID: ', responseResult);
                               if(responseResult.data.code === 200){
                                    console.log('response.data.data[0].HubName',responseResult.data.data[0].HubName);
                                     this.CurrentRTODetails.RTOTOName = responseResult.data.data[0].HubName;
                                     this.CurrentRTODetails.RTOTOHubId = responseResult.data.data[0].HubID;
                               }
                               else {
                                    this.CurrentRTODetails.RTOTOName = '';
                                    this.CurrentRTODetails.RTOTOHubId = '';
                               }

                               if(response.data.data.Status == 'RTO'){
                                this.shippingRTODetailsChangeHubShow = true;
                               }
                           })
                           .catch((httpException) => {
                               this.$alertify.error("Hub name not found");
                               this.CurrentRTODetails.RTOTOName = '';
                               this.CurrentRTODetails.RTOTOHubId = '';
                               console.error('exception is:::::::::', httpException)
                           })
                      } else{
                        this.$alertify.error("Shipment is not belongs to current hub.! ");
                      }
                    }
                    else {
                        this.$alertify.error('Unable to get shipment details.');
                    }
                })
              .catch((httpException) => {
                  this.$alertify.error("Unable to get shipment");
                  console.error('exception is:::::::::',httpException)
              });
              //this.shippingDetailsShow1 = true;
            }
          else if(this.rtodto === "3"){
            this.$alertify.error("This Functionality Yet Not developed");
          }else{
            this.$alertify.error("Please select shipment type");
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    validateForm2(scope) {
      //form2 NEW RTO Form
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          let RTOUpdatePayload = [];
          RTOUpdatePayload.push({
                shippingID : this.txtShipmentId,
                rtoName : this.NewRTODetails.newRTOName,
                rtoAddress : this.NewRTODetails.NewRTOAddress,
                rtoState : this.NewRTODetails.newRTOState,
                rtoCity : this.NewRTODetails.newRTOCity,
                rtoPincode : this.NewRTODetails.NewRTOPincode,
                rtoMobileno : this.NewRTODetails.NewRTOmobileno,
                comments : this.NewRTODetails.NewRTOReason,
                LastModifiedBy : this.localusermailid
          })
          //console.log('Payload: ',RTOUpdatePayload);
          axios.put(apiUrl.api_url + 'shipments/ChangeRTOShipmetAddress', RTOUpdatePayload)
          .then((response) => {

            if(response.data[0].code === 200){
              this.$alertify.success("Record Updated");
            }
            else {

                this.$alertify.error(response.data[0].message);
            }

          })
          .catch((httpException) => {
              this.$alertify.error("Unable to Update shipment");
              console.error('exception is:::::::::',httpException)
          });
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    validateForm5(scope) {
      //form5 Current RTOHub change Form
      this.$validator.validateAll(scope).then(result => {
        if (result) {
            //change RTO Deatails
            let RTOUpdatePayload = {
                  shippingID : this.txtShipmentId,
                  currentRTOhubID : (this.CurrentRTODetails.RTOTOHubId).toString(),
                  newRTOhubID : (this.CurrentRTODetails.changeRTOTOHubId).toString(),
                  comments : this.CurrentRTODetails.RTOReason,
                  LastModifiedBy : this.localusermailid
            }
            //console.log('Payload: ',RTOUpdatePayload);

            axios.put(apiUrl.api_url + 'shipments/ChangeRTOToHubId', RTOUpdatePayload)
            .then((response) => {
              //console.log("response.data.code",response.data.code);
              //console.log("response.data.code",response.data);

              if(response.data.code === 100){
                this.$alertify.success("Record Updated");
              }
              else {

                  this.$alertify.error(response.data.message);
              }

            })
            .catch((httpException) => {
                this.$alertify.error("Unable to Update shipment");
                console.error('exception is:::::::::',httpException)
            });


        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    validateForm1(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
        //  console.log('validateForm1',result);
          this.uploadCSV();
        }
      })
      this.shippingDetailsShow1 = true;
    },
    validateFormRTOupload(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          //JSON.stringify(smallarray)
          let BulkRTO = JSON.stringify(result);
          //console.log('validateFormRTOupload');
          this.uploadCSV();
        }
      })
    },
    validateForm3(scope) {
      this.$validator.validateAll(scope).then(result => {
          if (result) {
            var updateAddress = {
                shippingID : this.txtShipmentId.trim(),
            }
            //console.log('updateAddress',updateAddress);
            axios.post(apiUrl.api_url + 'shipmentMisrout/getShipmemtsdetails', updateAddress)
            .then((response) => {
              if(response.data.code === 200){
                if((response.data.data.CurrentHubID != '' || response.data.data.CurrentHubID != null) && response.data.data.CurrentHubID == this.hubdetails) {
                  if(response.data.data.IsRedirect == null){
                    this.rblBulkIsRedirect1 = 0;
                  }else{
                    this.rblBulkIsRedirect1 = 1;
                  }
                  this.shipDetails = {
                    'ShippingPincode' : response.data.data.CustomerAddressDetails.Primary.PinCode,
                    'mobileno' : response.data.data.CustomerContactDetails.Primary.PhoneNo,
                    'ShippingState' : '',
                    'ShippingCity' : '',
                    'shippingAddress' : response.data.data.CustomerAddressDetails.Primary.Address,
                    "ShippingComments" : '',
                  }
                  //console.log('this.shipDetails',this.shipDetails);
                  this.shippingDetailsShow1 = true;
                } else {
                  this.$alertify.error("Shipment is not belongs to current hub.! ");
                }
              }
              else {
                  this.$alertify.error(response.data.message);
              }

            })
          .catch((httpException) => {
            //console.log("hiiiiiiiii");
              this.$alertify.error("Unable to get shipment detail.!");
              console.error('exception is:::::::::',httpException)
          });
      }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    validateForm4(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          //console.log('form submited no4');
          let updateshippingDetails = [];
           updateshippingDetails.push({
              shippingID : this.txtShipmentId,
              shippingAddress : this.shipDetails.shippingAddress,
              shippingCity : this.shipDetails.ShippingCity,
              shippingState : this.shipDetails.ShippingState,
              shippingMobileno : this.shipDetails.mobileno,
              shippingPincode : (this.shipDetails.ShippingPincode).toString(),
              solID : this.shipDetails.SolID,
              comments : this.shipDetails.ShippingComments,
              LastModifiedBy : this.localusermailid
          })

          let checkStringExist = this.shipDetails.shippingAddress+this.shipDetails.ShippingCity+this.shipDetails.ShippingState+this.shipDetails.mobileno+(this.shipDetails.ShippingPincode).toString()+this.shipDetails.SolID+this.shipDetails.ShippingComments+this.localusermailid;
          console.log('Payload 3: ',updateshippingDetails);
          if(this.checkDuplicate !== checkStringExist){
            axios.put(apiUrl.api_url + 'shipment/lastmile/UpdateShipmentDetails', updateshippingDetails)
            .then((response) => {
              //console.log("response",response.data[0].message);
              //console.log("response",response.data[0]);
              //this.groupedErrors = response.data;
              //console.log('this.groupedErrors',this.groupedErrors);
              if(response.data[0].code === 200){
                this.$alertify.success("Record Updated");
                this.checkDuplicate = this.shipDetails.shippingAddress+this.shipDetails.ShippingCity+this.shipDetails.ShippingState+this.shipDetails.mobileno+(this.shipDetails.ShippingPincode).toString()+this.shipDetails.SolID+this.shipDetails.ShippingComments+this.localusermailid;
              }
              else {
                  this.$alertify.error(response.data[0].message);
              }
            })
            .catch((httpException) => {
                this.$alertify.error("Unable to Update shipment address");
                console.error('exception is:::::::::',httpException)
            });
          }else{
            this.$alertify.error("Already Updated");
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    getHubList(){

       axios.get(apiUrl.api_url + 'shipmentMisrout/gethublist', {})
        .then((response) => {
            if(response.data.code===200){
                this.changeRTOTOHubIdObj =response.data.data;
            }
            else {
                this.changeRTOTOHubIdObj = [];
            }
        })
        .catch((httpException) => {
            this.$alertify.error("hub data not found");
            console.error('exception is:::::::::', httpException)
        })

    },
    getUploadEvent(evt){
      this.handleFiles(evt)
    },
    handleFiles(evt) {
      //console.log('handleFiles', 'inside', 'evt:', evt)
      if (window.FileReader) {
        const files = evt.target.files || evt.dataTransfer.files
        //console.log('handleFiles', 'files:', files)
        this.getFileData(files[0], evt)
      } else {
        this.$alertify.error('FileReader are not supported in this browser.')
      }
    },
    getFileData(fileToRead, evt) {
      //console.log('getFileData', 'inside', 'fileToRead:', fileToRead, 'evt:', evt)
      var reader = new FileReader()
      reader.readAsText(fileToRead)
      reader.onload = function(e) {
        const csv = reader.result
        this.processData(csv, evt)
      }.bind(this)
      reader.onerror = function(e) {
        this.errorHandler(e)
      }.bind(this)
    },
    processData(csv, evt) {
    //console.log('In proceedd*******');
      const vm = this
      const allTextLines = csv.split(/\r\n|\n/)
      vm.csvRows = []
      for (let i = 1; i < allTextLines.length; i++) {
        if (allTextLines[i] !== '') {
          vm.csvHeaders = allTextLines ? allTextLines[0] : []
          const headers = vm.csvHeaders.split(',')
          var chlval = this.checkHeaderData(headers)
          if (chlval) {
            if(this.changeStatus == 0){
              document.getElementById("uploadRTO").removeAttribute('disabled')
            }else{
              document.getElementById("uploadFile").removeAttribute('disabled')
            }

            const data = allTextLines[i].split(/,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/)
            let obj = data.reduce(function(result, item, index) {
              result[headers[index]] = item || ''
              return result
            }, {})
            if (obj) {
              vm.csvRows.push(obj)
            }
          }
        }
      }
      if (this.csvRows.length <= 0) {
        if(this.changeStatus == 0){
          document.getElementById("uploadRTO").setAttribute("disabled", true)
        }else{
          document.getElementById("uploadFile").setAttribute("disabled", true)
        }
        return this.$alertify.error('Invalid column length: File is not uploaded')
      }
    },
    checkHeaderData(headers) {

      if(this.changeStatus == 0){
          var csvHeadersData = ['ShippingID', 'RTOName', 'RTOAddress', 'RTOState', 'RTOCity', 'RTOPinCode', 'RTOMobileNo', 'Comment']
      }else{
          var csvHeadersData = ['awb', 'solid', 'branchaddress', 'city', 'state', 'pincode', 'mobileno', 'comments', 'actionstatus', 'IsRedirct', 'LastModifiedBy']
      }

      var headerchk = true
      for (let j = 1; j < csvHeadersData.length; j++) {
        var chkHeaderColumn = headers.includes(csvHeadersData[j])
        //console.log("chkHeaderColumn",chkHeaderColumn);
        if (!chkHeaderColumn) {
          if(this.changeStatus == 0){
            var texcsv = document.getElementById('FileUploadRTO')
            texcsv.classList.add('is-danger')
            var csvwmsgtxt = document.getElementById('csvwmsgRTO')
          }else{
            var texcsv = document.getElementById('FileUpload1')
            texcsv.classList.add('is-danger')
            var csvwmsgtxt = document.getElementById('csvwmsgtxt')
          }
          csvwmsgtxt.innerHTML = 'Please check file column name [' + csvHeadersData[j] + '] is not correct or valid'
          csvwmsgtxt.style.display = 'block'
          csvwmsgtxt.style.color = 'red'
          return headerchk = false
        }else{
          var csvwmsgtxt = document.getElementById('csvwmsgRTO')
          var csvwmsgtxt1 = document.getElementById('csvwmsgtxt')
          csvwmsgtxt.style.display = 'none'
          csvwmsgtxt1.style.display = 'none'
        }
      }
      return headerchk
    },
      uploadCSV() {

      const obj = {
        updateAddress: this.csvRows.length > 0 ? this.csvRows : []
      }
      this.Loading = true;
      var result = obj.updateAddress
      var size = 50
      for (var k = 0; k < result.length; k += size) {

        var smallarray = result.slice(k, k + size)


        if (obj.updateAddress.length > 0) {
            if(this.changeStatus == 0){
              let payload=[];
              let ShippingAddress = smallarray;
              var errorShippind = [];
              ShippingAddress.forEach(shipAddress=>{
                var GetStateId = this.newRTOStateObj.filter(function(statecode) {
                return (
                    statecode.statecode.toLowerCase() == shipAddress.RTOState.toLowerCase() ||
                    statecode.statename.toLowerCase() == shipAddress.RTOState.toLowerCase()
                  );
                });
                var GetcityId = this.AllcitiesObj.filter(function(city) {
                  //console.log('city',city);
                  //console.log('shipAddress.RTOCity',shipAddress.RTOCity);
                return (
                    city.cityname.toLowerCase() == shipAddress.RTOCity.toLowerCase()
                  );
                });
                // console.log('GetcityId',GetcityId);
                // console.log('newRTOCityObj',GetStateId);
                if(GetcityId.length === 0){
                  errorShippind.push({"data": shipAddress.shippingID,"message":"City not exist"})
                }else if(GetStateId.length === 0){
                  errorShippind.push({"data": shipAddress.shippingID,"message":"State not exist"})
                }else {
                  errorShippind = [];
                  payload.push({
                    "shippingID" : shipAddress.shippingID,
                    "rtoName" : shipAddress.RTOName,
                    "rtoAddress" : shipAddress.RTOAddress,
                    "rtoCity": GetcityId[0].cityid,
                    "rtoState": GetStateId[0].stateid,
                    "rtoPincode":shipAddress.RTOPinCode,
                    "rtoMobileno" : shipAddress.RTOMobileNo,
                    "comments":shipAddress.Comment,
                    "LastModifiedBy" : this.localusermailid,
                    "CurrentHubID": this.hubdetails
                  });
                }
              })
              if(errorShippind.length ==  0) {
                  axios.put(apiUrl.api_url + 'shipments/ChangeRTOShipmetAddress', payload)
                  .then((response) => {
                    this.Loading = false;
                    this.groupedErrors = response.data
                  })
                  .catch((httpException) => {
                      this.$alertify.error("Unable to Update shipment address");
                      console.error('exception is:::::::::',httpException)
                  });
              }else{
                this.Loading = false;
                this.groupedErrors = errorShippind;
              }

            } else {
                let DropdetailPayload = [];
                var errorShippind = [];
                smallarray.forEach(shipAddress=>{

                  var GetStateId = this.newRTOStateObj.filter(function(statecode) {
                  return (
                      statecode.statecode.toLowerCase() == shipAddress.state.toLowerCase() ||
                      statecode.statename.toLowerCase() == shipAddress.state.toLowerCase()
                    );
                  });

                  var GetcityId = this.AllcitiesObj.filter(function(city) {
                  return (
                      city.cityname.toLowerCase() == shipAddress.city.toLowerCase()
                    );
                  });

                  if(GetcityId.length === 0){
                    errorShippind.push({"data": shipAddress.awb,"message":"City not exist"})
                  }else if(GetStateId.length === 0){
                    errorShippind.push({"data": shipAddress.awb,"message":"State not exist"})
                  }else {
                    errorShippind = [];
                    DropdetailPayload.push({
                      "shippingID": shipAddress.awb,
                      "shippingAddress": shipAddress.branchaddress,
                      "shippingCity": GetcityId[0].cityid,
                      "shippingState": GetStateId[0].stateid,
                      "shippingMobileno":shipAddress.mobileno,
                      "shippingPincode": shipAddress.pincode,
                      "solID":shipAddress.solid,
                      "comments":shipAddress.comments,
                      "LastModifiedBy":shipAddress.LastModifiedBy,
                      "CurrentHubID": this.hubdetails
                    });
                  }
                })
                if(errorShippind.length ==  0) {
                    axios.put(apiUrl.api_url + 'shipment/lastmile/UpdateShipmentDetails', DropdetailPayload)
                    .then((response) => {
                      this.Loading = false;
                      this.groupedErrors = response.data;
                    })
                    .catch((httpException) => {
                        this.$alertify.error("Unable to Update shipment address");
                        console.error('exception is:::::::::',httpException)
                        this.Loading = false;
                    });
              }else{
                this.Loading = false;
                this.groupedErrors = errorShippind;
              }
            }
        } else {
          this.$alertify.error('Error!')
        }
      }
    },
    onlyNumber($event){
       let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57 ) && keyCode !== 8 && keyCode !== 44) {
           $event.preventDefault();
        }
     },
     downloadCSV() {

       if(this.changeStatus == 0){

           var csvData = [{
             shippingID: '',
             RTOName : '',
             RTOAddress : '',
             RTOState : '',
             RTOCity: '',
             RTOPinCode : '',
             RTOMobileNo : '',
             Comment : ''
           }]
       } else {
         var csvData = [{
           awb: '',
           solid: '',
           branchaddress: '',
           city: '',
           state: '',
           pincode: '',
           mobileno: '',
           comments: '',
           actionstatus: '',
           IsRedirct: '',
           LastModifiedBy: ''
         }]
       }

       var today = new Date()
       var dd = today.getDate()
       var mm = today.getMonth() + 1
       var yyyy = today.getFullYear()
       var today = dd + '' + mm + '' + yyyy
       var data, link;

       var csv = this.convertArrayOfObjectsToCSV({
         data: csvData
       })

        var buffer = Array.prototype.join.call(csv, "");
        var blob = new Blob([buffer], {
            "type": "text/csv;charset=utf8;"
        });

       link = document.createElement('a')
       link.setAttribute('href', blob)

       if (link.download !== undefined) {
            var filename='';
            console.log('this.changeStatus',this.changeStatus);
            if(this.changeStatus == 0){

              filename = 'BulkRTOFile' + today + '.csv'
            }else {
              filename = 'UpdateShipmentDetailsCSV' + today + '.csv'
            }

            link.setAttribute("href", window.URL.createObjectURL(blob));
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            alert('CSV export only works in Chrome, Firefox, and Opera.');
        }

       // link.setAttribute('download', filename)
       // link.click()
     },
     convertArrayOfObjectsToCSV: function(args) {
       var result, ctr, keys, columnDelimiter, lineDelimiter, data
       data = args.data || null
       if (data == null || !data.length) {
         return null
       }
       columnDelimiter = args.columnDelimiter || ','
       lineDelimiter = args.lineDelimiter || '\n'
       keys = Object.keys(data[0])
       result = ''
       result += keys.join(columnDelimiter)
       result += lineDelimiter
       data.forEach(function(item) {
         ctr = 0
         keys.forEach(function(key) {
           if (ctr > 0) result += columnDelimiter
           result += item[key]
           ctr++
         })
         result += lineDelimiter
       })
       return result
     },
    clearFile(){

      const input = this.$refs.fileupload;
      input.type = 'text';
      input.type = 'file';

      const input1 = this.$refs.fileupload1;
      input1.type = 'text';
      input1.type = 'file';
      this.groupedErrors = '';
      document.getElementById('csvwmsgtxt').style='display:none';
      document.getElementById('csvwmsgRTO').style='display:none';
      this.$validator.reset();
      this.errors.clear();

    },
    clearAll(){
      console.log('clear  ALL');
      this.rtodto = '';
      this.changeShipmentStatusflagrtodto = '';
      this.changeShipmentStatusflag = '';
      this.txtShipmentId = '';
      this.txtShipmentId1 = '';
      this.groupedErrors = [];
      this.shipDetails = [];
      this.CurrentRTODetails = [];
      this.PrevRTODetails = [];
      this.NewRTODetails = [];
      this.shippingDetailsShow = false;
      this.shippingRTODetailsShow = false;
      this.shippingRTODetailsChangeHubShow = false;
      this.shippingDetailsShow1 = false;

      this.$validator.reset();
      this.errors.clear();
    },
    clear(){
      this.shippingDetailsShow=false;
      this.shippingRTODetailsShow = false;
      this.shippingRTODetailsChangeHubShow = false;
      this.txtShipmentId='';
      this.shippingDetailsShow1=false;
      this.txtShipmentId1='';
      this.NewRTODetails = {};
      this.CurrentRTODetails = {};
      this.PrevRTODetails = {};

      this.$validator.reset();
      this.errors.clear();
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ChangeRTOandShipmentDetails/ChangeRTOandShipmentDetails.component.js